import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Cart.css";

const Cart = (props) => {
  const { country, name, number, img, money } = props.player;
  return (
    <div className="d-flex justify-content-center align-items-center pl-4">
      <div className="">
        <div className="player-image text-center">
          <img className="rounded ml3" src={img} alt="" />
        </div>
        <div className="player-details text-center d-flex justify-content-center align-items-center">
          <div className="">
            <h3>Name: {name}</h3>
            <h4>Number: {number}</h4>
            <h4>Country: {country}</h4>
            <h4>Salary: ${money}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
